import { render, staticRenderFns } from "./WelfareAnnouncement.vue?vue&type=template&id=5e5025a4&scoped=true&"
import script from "./WelfareAnnouncement.vue?vue&type=script&lang=js&"
export * from "./WelfareAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./WelfareAnnouncement.vue?vue&type=style&index=0&id=5e5025a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5025a4",
  null
  
)

export default component.exports